import { helpers } from "../../../ui/util/helpers.ts";
import { createMobileCrossTabHref } from "../../util/mobileCrossTabLink.ts";
import i18n from "../../util/i18n.ts";
import { formatPlayerNameFromLegacyName } from "../../util/playerNames.ts";
import { TeamAbbrevText } from "../../components/TeamAbbrevLink.tsx";
import { createMobileReturnUrl } from "../../util/mobilePageContext.ts";

const TEAM_TITLE_KEYS: Record<string, string> = {
	"First Team": "history.firstTeam",
	"Second Team": "history.secondTeam",
	"Third Team": "history.thirdTeam",
};

const translateTeamTitle = (title: string): string => {
	const key = TEAM_TITLE_KEYS[title];
	if (!key || !i18n.isInitialized) return title;
	const t = i18n.t(key, { ns: "ui", defaultValue: title });
	return typeof t === "string" && t.length > 0 ? t : title;
};

const getMobileScrollY = () => (typeof window !== "undefined" ? window.scrollY : undefined);

const createHistoryPlayerHref = (pid: number, season: number) =>
	createMobileReturnUrl(helpers.leagueUrl(["player", pid]), {
		activeTab: String(season),
		filterKey: "historySeason",
		filterValue: season,
		pageID: "history",
		scrollY: getMobileScrollY(),
	});

const Player = ({
	p,
	season,
	userTid,
}: {
	p: any;
	season: number;
	userTid: number;
}) => {
	// The wrapper div here actually matters, don't change to fragment!
	return (
		<div>
			<span className={p.tid === userTid ? "table-info" : undefined}>
				<a href={createHistoryPlayerHref(p.pid, season)}>
					{formatPlayerNameFromLegacyName(p.name)}
				</a>{" "}
				(
				<a
					href={createMobileCrossTabHref(
						helpers.leagueUrl(["roster", `${p.abbrev}_${p.tid}`, season]),
					)}
				>
					<TeamAbbrevText tid={p.tid} abbrev={p.abbrev} />
				</a>
				)
			</span>
		</div>
	);
};

const Teams = ({
	className,
	name,
	nested = false,
	season,
	team,
	userTid,
}: {
	className?: string;
	name: string;
	nested?: boolean;
	season: number;
	team: any[];
	userTid: number;
}) => {
	let content;

	if (nested) {
		content = team.map((t) => {
			if (t.players.length === 0) {
				return null;
			}

			return (
				<div className="mb-3" key={t.title}>
					<h3>{translateTeamTitle(t.title)}</h3>
					{t.players.map((p: any) =>
						p ? (
							<Player key={p.pid} p={p} season={season} userTid={userTid} />
						) : (
							""
						),
					)}
				</div>
			);
		});
	} else if (team.length === 0) {
		content = <p>{i18n.t("history.none", { ns: "ui", defaultValue: "None" })}</p>;
	} else {
		content = team
			.filter(Boolean)
			.map((p) => (
				<Player key={p.pid} p={p} season={season} userTid={userTid} />
			));
	}

	return (
		<div className={className}>
			<h2>{name}</h2>
			{content}
		</div>
	);
};

export default Teams;
